module.exports = __webpack_public_path__ + "static/img/shipinjinyong.59654cb3.svg";